import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import LogoEmblem from "@/components/LogoEmblem";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page introuvable — NB Couverture";
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0D0F12] px-6 text-center text-slate-200">
      <LogoEmblem size={72} />
      <h1 className="mt-8 font-serif text-4xl font-semibold text-white md:text-6xl">Page introuvable</h1>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
        Cette page n'existe pas ou plus. Retournez à l'accueil pour découvrir nos prestations de couverture et
        zinguerie à Bordeaux.
      </p>
      <Link
        to="/"
        data-testid="notfound-home"
        className="group mt-8 inline-flex items-center gap-3 rounded-full bg-terra px-7 py-4 text-sm font-semibold text-white transition-colors duration-300 hover:bg-terra-hover"
      >
        <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" />
        Retour à l'accueil
      </Link>
    </div>
  );
}
